import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IEvent } from './types';

export const getEvent = async (eventId: string): Promise<IEvent> => {
  try {
    const url = `${API_URL}/events/${eventId}`;
    const res = await fetch(url);

    if (!res.ok) throw new Error();

    const response = await res.json();
    return response.data;
  } catch (e) {
    throw new Error(`Could not fetch event: ${e.message}`);
  }
};
